<template>
  <Audio-recorder
    :source="source"
    :story-id="storyId"
    :analytics-data="analyticsData"
    :enable-intercom="true"
    :isEmbedded="!app.isEmbedded"
    :use-pop-up="usePopUp"
    :reset-confirm-template="app.dialog.types.CONFIRM_3"
    :close-confirm-template="app.dialog.types.CONFIRM_2"
    :error-dialog-template="app.dialog.types.ERROR_1"
    :close-modal="closeModal"
    :dynamic-file-name-suffix="savedFileSuffix"
    @intercom-request="contactSupport"
    @analytics="onAnalytics"
    @open-upload-modal="$_onOpenUploadModal"
    @update-dynamic-file-name-suffix="updateRemoteStash"
    :download-on-save="true"
    :predefined-voice-id="voiceId"
    :predefined-transcript="transcript"
    :predefined-ai-voice-speed="aiVoiceSpeed"
  />
</template>

<script>
import AudioRecorder from 'components/recorder';
import Analytics from 'c/WtAnalytics';
import app from 'app';
import api from 'v/Story/Lightbox/api';

export default {
  name: 'wtVoiceRecorder',
  components: {
    AudioRecorder,
  },

  props: {
    closeModal: { type: Function, required: false },
    source: { type: String, required: false },
    storyId: { type: String, required: true },
    analyticsData: { type: Object },
    voiceId: { type: String, required: false },
    transcript: { type: String, required: false },
    aiVoiceSpeed: { type: Number, required: false },
  },

  data() {
    return {
      app,
      savedFileSuffix: this.getRemoteStash() || 1,
    };
  },

  beforeCreate() {
    this.$api = api();
  },

  computed: {
    isDestroyed() {
      return this._isDestroyed;
    },
  },

  methods: {
    usePopUp(payload) {
      switch (payload.type) {
        case app.dialog.types.CONFIRM_3:
          return app.dialog.confirm({
            type: payload.type,
            title: 'Are you sure?',
            description: 'Your recording will not be saved.',
            buttonYesText: 'Yes, record again',
            buttonNoText: app.culture.generic.CANCEL,
            buttonYesAction: true,
          });
        case app.dialog.types.CONFIRM_2:
          return app.dialog.confirm({
            type: payload.type,
            title: 'Your recording is not saved',
            buttonYesText: 'OK, delete',
            buttonNoText: app.culture.generic.CANCEL,
          });
        default:
          return app.dialog.error({
            type: payload.type,
            title: payload.title,
            description: payload.description,
            showContactCsm: payload.showContactCsm,
          });
      }
    },
    getRemoteStash() {
      return app.storyController.story.remoteStash.get('topVoicesRecorded');
    },
    updateRemoteStash() {
      this.savedFileSuffix += 1;
      return app.storyController.story.remoteStash.set(
        'topVoicesRecorded',
        this.savedFileSuffix
      );
    },
    $_onOpenUploadModal(payload) {
      this.$api.showMediaUploadView({
        initEvent: payload.e,
        storyId: this.storyId,
        analyticsData: {
          using: 'button',
          'from screen': 'Record Audio',
          source: payload.source,
        },
      });
    },
    onAnalytics(data) {
      if (data.payload) {
        return Analytics.trigger(data.eventName, data.payload);
      }
      Analytics.trigger(data.eventName);
    },
    contactSupport(errorType) {
      let message;
      switch (errorType) {
        default:
          message =
            "Hi. I'm having trouble with giving access the " +
            'microphone in the Audio Recorder, can you assist?';
      }

      app.intercomController.showNewMessage(message).catch(() => {
        // fallback - if there no intercom, go to website support
        app.openSupportTab();
      });
    },
  },
};
</script>

<style lang="scss"></style>
